import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Map } from 'immutable'
import _ from 'lodash'

import config from '../../../../../../config'

import { openPortfolioById } from '../../actions'

import { PortfolioRecord } from './reducer'

const MODULE_KEY = config.modules.portfolio.key

function mapStateToProps(state) {
    const activeModule = state.getIn(['ui', 'moduleMenu', 'active'])
    const activeTab = state
        .getIn(['ui', 'tabs', 'tabs'])
        .find((tab) => tab.get('active') === true && tab.get('type') === activeModule)
    const id = activeTab && activeTab.get('id', null)
    let data = state.getIn(['ui', 'modules', MODULE_KEY, 'workspace', id])
    if (_.isNil(data)) data = new PortfolioRecord()

    const activePortfolioType = state.getIn(['ui', 'modules', MODULE_KEY, 'ribbon', 'portfolios', 'active'], null)
    const blocks = state.getIn(
        ['authorization', 'accessRights', MODULE_KEY, 'custom', 'portfolios', activePortfolioType, 'blocks'],
        Map()
    )
    const sortedBlocks = blocks
        .toList()
        .sortBy((b) => b.get('order'))
        .map((b) => b.get('name'))
        .toArray()

    const noBlockShown = !data.get('blocks', Map()).some((b) => b.get('active', false))

    const parameters = state.getIn(
        ['authorization', 'accessRights', MODULE_KEY, 'custom', 'portfolios', activePortfolioType, 'parameters'],
        Map()
    )

    return {
        activePortfolioId: id,
        portfolioData: {
            name: data.getIn(['name']),
            count: data.getIn(['counts', 'toAnalyze']),
            naturalPerson: data.getIn(['counts', 'naturalPerson']),
            foreign: data.getIn(['counts', 'foreign']),
            outOfBusiness: data.getIn(['counts', 'outOfBusiness']),
        },
        sortedBlocks,
        noBlockShown,
        banner: {
            line: parameters.get('upsellInline', false),
            carousel: parameters.get('upsellCarousel', false),
        },
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ openPortfolioById }, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
